<script setup lang="ts">
defineProps<{
  title: string,
}>();
</script>

<template>
  <p class="text-sm font-semibold text-(--color-sidebar-text)">
    {{ title }}
  </p>
</template>
